module.exports = __webpack_public_path__ + "assets/voice/new_self_pickup.MP3";